export default __webpack_public_path__ + "static/media/sf2.5fd06ca3.jpeg";